<script>
import dateFormat from "@/shared/lib/date-format";
import InformationLayout from "@/shared/ui/information-layout/InformationLayout.vue";
import { FormItem, FormLabel, FormControl } from "@/shared/ui/form";
import { Input } from "@/shared/ui/input";

export default {
  name: "TariffData",
  components: { InformationLayout, FormItem, FormLabel, FormControl, Input },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    selectedTariff: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    uuid() {
      return this.$route.params.id;
    },
    showForm() {
      return this.$route.name === "mrp_new" || this.$route.name === "mrp_item";
    },

    sections() {
      if (!this.selectedTariff) return [];

      const tariff = this.selectedTariff;

      return [
        {
          title: this.$t("Данные МРП"),
          items: [
            {
              label: this.$t("Наименование МРП"),
              values: [
                { lang: "Рус", text: tariff.name },
                { lang: "Қаз", text: tariff.name_kz },
              ],
            },
            {
              label: this.$t("Код"),
              values: [{ text: tariff.code }],
            },
            {
              label: this.$t("Дата создания"),
              values: [{ text: this.dateFormat(tariff.created_at) }],
            },
            {
              label: this.$t("Дата изменение"),
              values: [{ text: this.dateFormat(tariff.changed_at) }],
            },
            {
              label: this.$t("Стоимость"),
              values: [
                {
                  text: tariff.value || "-",
                },
              ],
            },
          ],
        },
      ];
    },
  },
  methods: {
    async validate() {
      return true;
    },
    onlyDigits(e) {
      this.form.value = e.target.value.replace(/\D/g, "");
    },
    dateFormat(date) {
      if (!date) {
        return this.$t("Не указано");
      }
      return dateFormat.timestamp_to_local_tz(date, "DD.MM.YYYY, HH:mm");
    },
  },
};
</script>

<template>
  <div class="block">
    <div v-if="showForm" class="flex flex-col gap-8 w-full">
      <div class="flex flex-col gap-3">
        <div class="text-foreground text-lg font-semibold leading-6">
          {{ $t("Параметры МРП") }}
        </div>
      </div>

      <div class="flex flex-col gap-3">
        <div class="flex flex-col gap-1">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <FormItem float>
              <FormControl>
                <Input v-model="form.name" placeholder="" />
              </FormControl>
              <FormLabel>{{ $t("Наименование МРП (рус)") }}</FormLabel>
            </FormItem>

            <FormItem float>
              <FormControl>
                <Input v-model="form.name_kz" placeholder="" />
              </FormControl>
              <FormLabel>{{ $t("Наименование МРП (қаз)") }}</FormLabel>
            </FormItem>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <FormItem float>
              <FormControl>
                <Input v-model="form.code" placeholder="" class="w-full" />
              </FormControl>
              <FormLabel>{{ $t("Код") }}</FormLabel>
            </FormItem>

            <FormItem float>
              <FormControl>
                <Input
                  v-model="form.value"
                  placeholder=""
                  class="w-full"
                  inputmode="numeric"
                  @input="onlyDigits"
                />
              </FormControl>
              <FormLabel>{{ $t("Стоимость скидки") }}</FormLabel>
            </FormItem>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.name === 'mrp_item_view'">
      <InformationLayout :showHeader="false" :sections="sections" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.block {
  @apply h-full w-1/2 overflow-auto bg-card rounded-2xl p-8;
}

@media (max-width: 1400px) {
  .block {
    @apply w-full;
  }
}
</style>
